module.exports = __webpack_public_path__ + "efe1b6c6d4d81af22b4be792598a7298.jpg";